import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import TimerModal from "../TimerModal/TimerModal";
import { sessionPopUp } from "../../selectors/globalSelectors";
class SessionTimeOut extends PureComponent {

  
  render() {
    const { showSessionPopUp } = this.props;
    return (
      <div>
        {showSessionPopUp === true ? (
          <TimerModal show={showSessionPopUp} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

SessionTimeOut.propTypes = {
  showSessionPopUp: PropTypes.bool
}

const mapStateToProps = state => {
  return {
    showSessionPopUp: sessionPopUp(state.toJS())
  };
};


export default withRouter(
  connect(
    mapStateToProps,
    null
  )(SessionTimeOut)
);
